import React, { useMemo } from "react";
import { useReactTable, getCoreRowModel, flexRender } from "@tanstack/react-table";

const Jctable3 = ({ data }) => {
  const tableData = useMemo(() => {
    return (
      data?.map((item) => ({
        LOB: item.key.LOB || "",
        PPL: item.key.PPL || "",
        PL: item.key.PL || "",
        Count: item.doc_count || 0,
      })) || []
    );
  }, [data]);

  const columns = useMemo(() => {
    if (!tableData.length) return [];
    return Object.keys(tableData[0]).map((key) => ({
      accessorKey: key,
      header: key,
      cell: (info) => info.getValue(),
    }));
  }, [tableData]);

  const table = useReactTable({
    data: tableData,
    columns,
    getCoreRowModel: getCoreRowModel(),
  });

  const columnWidth = table.getAllColumns().length
    ? `${100 / table.getAllColumns().length}%`
    : "auto";

  return (
    <div className="w-full border rounded overflow-hidden">
      {/* Table Head */}
      <table className="w-full table-fixed border border-gray-300 text-center">
        <thead className="bg-gray-200 text-xs">
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th
                  key={header.id}
                  className="border border-gray-300 px-2 py-2 text-center break-words whitespace-normal"
                  style={{ width: columnWidth }}
                >
                  {flexRender(header.column.columnDef.header, header.getContext())}
                </th>
              ))}
            </tr>
          ))}
        </thead>
      </table>

      {/* Scrollable Body */}
      <div
        style={{ maxHeight: "250px", overflowY: "auto", overflowX: "hidden" }}
        className="scrollbar-thin scrollbar-thumb-gray-400 scrollbar-track-gray-100"
      >
        <table className="w-full table-fixed border border-t-0 border-gray-300 text-center">
          <tbody className="text-xs text-gray-700">
            {table.getRowModel().rows.length ? (
              table.getRowModel().rows.map((row, rowIndex) => (
                <tr
                  key={row.id}
                  className={rowIndex % 2 === 0 ? "bg-white" : "bg-gray-50"}
                >
                  {row.getVisibleCells().map((cell) => {
                    const value = cell.getValue()?.toString() || "";
                    return (
                      <td
                        key={cell.id}
                        className="border px-2 py-1 text-center break-words whitespace-normal"
                        style={{ width: columnWidth }}
                        title={value}
                      >
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                      </td>
                    );
                  })}
                </tr>
              ))
            ) : (
              <tr>
                <td
                  colSpan={columns.length}
                  className="border px-2 py-4 text-center text-gray-500"
                >
                  No data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Jctable3;
